"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.urlify = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const urlify = (text)=>{
    const urlRegex = /(https?:\/\/\S+)|(www?\.\S+)/g;
    const textParts = text.split(urlRegex).filter((item)=>item);
    return textParts.map((part)=>urlRegex.test(part) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Link, {
            href: part,
            target: "_blank",
            fontWeight: "bold",
            children: part
        }, part) : part);
};
exports.urlify = urlify;
